var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.896484H513V342.889H0V0.896484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 238.806H513V342.889H0V238.806Z",
    fill: "#1A7E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.896484H513V105.616H0V0.896484Z",
    fill: "#CF0D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 126.682H513V216.513H0V126.682Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.892578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGm);
export default __webpack_public_path__ + "static/media/GM.e11446b1bf5e63c3b47e532f8703f1dc.svg";
export { ForwardRef as ReactComponent };